var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "258px",
    height: "122px",
    viewBox: "0 0 258 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.-Illustration/-empty",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F3F8FE",
    points: "173.942388 49.2314203 150.309165 14.1296578 224.542751 14.1296578 247.981464 49.2314203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.044457,62.6923213 L147.042623,62.6923213 L147.042623,113.759381 L214.321923,113.767958 C215.597412,113.770173 216.670673,112.694475 216.670673,111.421357 L216.044457,62.6923213 Z",
    id: "Path",
    fill: "#F3F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.865921,0 C222.095413,0 223.238375,0.598800217 223.935277,1.61243396 L257.343485,50.1745297 C259.036988,52.6273656 257.254849,56.0097408 254.27424,56.0097408 L224.590302,56.0097408 L224.592521,111.463206 C224.592521,116.863991 220.198223,121.26 214.794083,121.26 L43.2106228,121.26 C37.8064256,121.26 33.4076393,116.863934 33.4076393,111.463206 L33.4076393,56.0097408 L3.72597341,56.0097408 C0.738728099,56.0097408 -1.03677436,52.6297503 0.65883384,50.1744764 L34.0602246,1.61465178 C34.7570694,0.601074818 35.9067354,0.00221782064 37.12958,0.00221782064 Z M132.757753,16.2513402 L132.757753,113.759381 L214.338636,113.759381 C215.605049,113.761588 216.670673,112.689822 216.670673,111.421357 L216.669204,56.1700085 L161.507785,56.1700085 C160.27447,56.1700085 159.118364,55.5490142 158.432235,54.5236411 L132.757753,16.2513402 Z M125.243163,16.2513402 L99.5703055,54.5229985 C98.8776122,55.5483544 97.7281874,56.1693383 96.4949505,56.1693383 L41.3302439,56.1693383 L41.3302439,111.419194 C41.3302439,112.687637 42.4024078,113.759381 43.6665378,113.759381 L125.243163,113.757741 L125.243163,16.2513402 Z M219.633741,7.50061856 L136.515048,7.50061856 L164.226595,48.7540206 L247.981464,48.7540206 L219.633741,7.50061856 Z M122.7383,7.50061856 L39.6237293,7.50061856 L11.2718847,48.7540206 L95.0271783,48.7540206 L122.7383,7.50061856 Z",
    id: "Combined-Shape",
    fill: "#CCDAEC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.956c6ef9bb2283e36824a76e16fdd999.svg";
export { ForwardRef as ReactComponent };